import { render, staticRenderFns } from "./Twist-Notification.vue?vue&type=template&id=73988bc6"
import script from "./Twist-Notification.vue?vue&type=script&lang=js"
export * from "./Twist-Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports